<script>
    import { createEventDispatcher } from 'svelte';

    import Checkbox from '../Checkbox.svelte';
    import State from '../State/State.svelte';

    let overrideNextDue = false;
    let endOfMonthAdj = false;

    const dispatch = createEventDispatcher();

    $: isStateDisabled = !overrideNextDue;
</script>

<div class="next-due">
    <div class="next-due__controls">
        <Checkbox
            bind:checked={overrideNextDue}
            on:change={({ detail: value }) => dispatch('change', { fieldName: 'override_next_due', value })}
        >
            Override Next Due
        </Checkbox>

        <Checkbox
            bind:checked={endOfMonthAdj}
            on:change={({ detail: value }) => dispatch('change', { fieldName: 'end_of_month_adj', value })}
        >
            End of Month Adj
        </Checkbox>
    </div>

    <State
        {...$$restProps}
        isDisabled={isStateDisabled}
        on:change={({ detail: value }) => dispatch('change', value)}
    />
</div>

<style>
    .next-due__controls {
        display: flex;
        column-gap: 30px;
        margin-bottom: 10px;
    }
</style>
